export default (updateSearch) => {
  Array.from(document.querySelectorAll('.product-search__filter-search')).forEach((input) => {
    input.addEventListener('keyup', () => {
      updateSearch({ [input.name]: input.value });
    });
    if (input.value.length) {
      updateSearch({ [input.name]: input.value });
    }
  });
};
